import type { ComponentProps } from 'react';
import { useCallback, useState } from 'react';

import type { PageMessage } from '@change-corgi/design-system-legacy/components/alerts';

type Banner = ComponentProps<typeof PageMessage>;

export type UseBannerStateReturn = ModelHookResult<
	{ currentBanner: Banner | undefined },
	{ addBanner: (banner: Banner) => void; dismissBanner: () => void }
>;
export function useBannerState(): UseBannerStateReturn {
	const [bannerQueue, setBannerQueue] = useState<Banner[]>([]);

	const handleAddBanner = useCallback((banner: Banner) => {
		setBannerQueue((queue) => [banner, ...queue]);
	}, []);

	const handleDismissBanner = useCallback(() => {
		setBannerQueue(([_, ...rest]) => rest);
	}, []);

	const currentBanner = bannerQueue.at(0);

	return { data: { currentBanner }, actions: { addBanner: handleAddBanner, dismissBanner: handleDismissBanner } };
}
